<script setup lang="ts">
import { LoaderCircle } from '@lucide/vue';
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
const props = defineProps<{ class?: HTMLAttributes['class']; label?: string }>();
</script>

<template>
  <span role="status" class="inline-flex items-center gap-2 text-sm text-muted-foreground">
    <LoaderCircle :class="cn('size-4 animate-spin', props.class)" aria-hidden="true" />
    <span v-if="label">{{ label }}</span
    ><span v-else class="sr-only">Загрузка</span>
  </span>
</template>
